
import {Component, Vue, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";
import KeyManagersAutocomplete from "@/components/keys/managers/KeyManagersAutocomplete.vue";

@Component({
  components: { KeyManagersAutocomplete },
})
export default class KeyAddManagersDialog extends Vue {

    @Prop({default: null})
    public keyId: number;

    @Prop({default: null})
    public keyGroupId: number;

    @Prop({default: () => ["user", "subordinates"]})
    public types: Array<"user"|"subordinates">;

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;

    private addManagerDialog: boolean = true;
    private newKeyManagers: any[] = [];
    private loadingAddManager: boolean = false;

    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private mounted(): void {
      //
    }

    private async addManager(): Promise<void> {
      this.loadingAddManager = true;
      const module = this.keyId ? "keys" : "keyGroups";
      await this.$store.dispatch(`${module}/addManagers`, {
        id: this.keyId || this.keyGroupId,
        userGroups: this.newKeyManagers,
      })
        .then(() => {
          this.$store.commit("alerts/displaySuccess", {
            icon: "icon-picto_mes-contacts",
            msg: this.$t("key.managerAdd"),
          });
          this.$emit("success");
        })
        .catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        })
        .finally(() => {
          this.loadingAddManager = false;
        });
    }
}
